import { render } from "./AdFilters.vue?vue&type=template&id=1800dbf0"
import script from "./AdFilters.vue?vue&type=script&lang=js"
export * from "./AdFilters.vue?vue&type=script&lang=js"
script.render = render

export default script